<template>
  <ABadge :class="tag.style">
    <template #icon>
      <Icon height="16" width="16" class="mr-1" />
    </template>
    <span v-text="$t(tag.label)"></span>
  </ABadge>
</template>

<script>
import ABadge from '../ABadge.vue'
import Icon from '../icons/CheckMark.vue'
import tags from '@/assets/aeropost-local-tags.json'

export default {
  components: {
    ABadge,
    Icon,
  },
  computed: {
    tag() {
      const now = new Date()

      return tags.find(({ start, end }) => now > new Date(start) && now < new Date(end)) || {
          label: 'badges.verifiedSeller',
          style: 'bg-green-200 text-green-900',
      }
    },
  },
}
</script>
